import Cookie from 'js-cookie';
import {SELLER_APP_AUTH_TOKEN_KEY, SELLER_ACCOUNT_ID_KEY} from 'utils/api/cookieUtils';
import {sellerLogo} from 'utils/getAppLogo';

export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SELLER_ACCOUNT_ID = 'SELLER_ACCOUNT_ID';

const commonStore = {
  namespaced: true,
  state: {
    appConfig: {},
    authToken: null,
    sellerAccountId: null,
    appLoading: false
  },
  getters: {
    appLoading (state) {
      return state.appLoading;
    },
    authToken (state) {
      return state.authToken || Cookie.get(SELLER_APP_AUTH_TOKEN_KEY);
    },
    sellerAccountId (state) {
      return state.sellerAccountId || Number(Cookie.get(SELLER_ACCOUNT_ID_KEY));
    },
    isDevelopment () {
      // eslint-disable-next-line no-undef
      return DEBUG;
    },
    activeCurrency () {
      return {
        code: 'RUB',
        full_name: 'RUB (Russian Ruble)',
        id: 1,
        name: 'Russian Ruble',
        symbol: '₽'
      };
    },
    activeCurrencySymbol (state, getters) {
      const currency = getters.activeCurrency;
      if (!currency) {
        return '';
      }

      return currency.symbol;
    },
    appName (state) {
      return state.appConfig.APP_NAME;
    },
    baseTochkaRedirectUrl (state) {
      return state.appConfig.BASE_URL_TOCHKA_REKLAMA;
    },
    appEnvName (state) {
      return state.appConfig.ENVIRONMENT;
    },
    posthogToken (state) {
      return state.appConfig.POSTHOG_TOKEN;
    },
    appLogo () {
      return {
        sellerLogo
      };
    }
  },
  mutations: {
    [SET_APP_CONFIG] (state, val) {
      const oldConfig = state.appConfig;
      state.appConfig = {...oldConfig, ...val};
    },
    [SET_AUTH_TOKEN] (state, val) {
      state.authToken = val;
    },
    [SELLER_ACCOUNT_ID] (state, val) {
      state.sellerAccountId = val;
    },
    [SET_APP_LOADING] (state, val) {
      state.appLoading = val;
    }
  },
  actions: {
    [SET_AUTH_TOKEN] (context, {token, expires, accountIdFromAuth}) {
      context.commit(SET_AUTH_TOKEN, token);
      context.commit(SELLER_ACCOUNT_ID, accountIdFromAuth);

      Cookie.remove(SELLER_APP_AUTH_TOKEN_KEY);
      Cookie.set(SELLER_APP_AUTH_TOKEN_KEY, token, {expires});

      Cookie.remove(SELLER_ACCOUNT_ID_KEY);
      Cookie.set(SELLER_ACCOUNT_ID_KEY, accountIdFromAuth, {expires});
    },
    [SET_APP_CONFIG] (context, val) {
      context.commit(SET_APP_CONFIG, val);
    },
    [SET_APP_LOADING] (context, val) {
      context.commit(SET_APP_LOADING, val);
    }
  }
};

export default commonStore;
